import * as React from 'react';
import AudioPlayer from './AudioPlayer';

import getPreloaded from './getPreloaded';
import type {Episode, Podcast} from './models';
import Playlist from './Playlist';
import {Provider as ThemeProvider} from './ThemeProvider';

const PlayerPlaylist = () => {
  const {podcast, episodes, colors} = getPreloaded() as {
    podcast: Podcast;
    episodes: Array<Episode>;
    colors: {accentColor: string; primaryColor: string; secondaryColor: string};
  };
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  return (
    <ThemeProvider value={colors}>
      <AudioPlayer
        podcast={podcast}
        episode={episodes[selectedIndex]}
        hasNext={episodes.length - 1 > selectedIndex}
        hasPrevious={selectedIndex > 0}
        onNext={React.useCallback(() => setSelectedIndex(idx => idx + 1), [])}
        onPrevious={React.useCallback(
          () => setSelectedIndex(idx => idx - 1),
          [],
        )}
      />
      <Playlist
        episodes={episodes}
        selectedIndex={selectedIndex}
        onSelect={setSelectedIndex}
      />
    </ThemeProvider>
  );
};

export default PlayerPlaylist;
